import {GoogleAnalyticsService} from '../../service/utils/google-analytics.service';
import {UserAgentService} from '../../service/utils/user-agent.service';
import {WindowService} from '../../service/window/window.service';
import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {Observable, Subscription} from 'rxjs';

@Component({
  selector: 'app-download',
  templateUrl: './download.component.html',
  styleUrls: ['./download.component.scss']
})
export class DownloadComponent implements OnInit {

  public isMobile: boolean;

  private _timer: Subscription;

  constructor(
    private _router: Router,
    private _windowServ: WindowService,
    private _uaServ: UserAgentService,
    private _gaServ: GoogleAnalyticsService) {
  }

  ngOnInit() {
    this._windowServ.scrollTop();
    this.isMobile = this._uaServ.isMobile();
  }

  public onClickDownload(event: Event): void {
    this._timer = Observable.interval(1500).subscribe(
      () => {
        if (this._timer) {
          this._timer.unsubscribe();
        }

        if (this.isMobile) {
          this._gaServ.sendLinkClickEvent('download-page', 'Next Page');
        } else {
          this._gaServ.sendMp3DownloadClickEvent('download-page', 'starbright.mp3');
        }

        this._router.navigate(['/links']);
        return;
      }
    );
  }

  public onClickPlayMusic(event: Event): void {
    this._gaServ.sendMp3PlayerClickEvent('download-page', 'starbright.mp3');
  }
}



// WEBPACK FOOTER //
// /Users/mizunoe_jing/Documents/nice_day_current/bitbucket/starbright/src/app/pages/download/download.component.ts